/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{BindType as s}from"../shaderTechnique/BindType.js";class a{constructor(a,i,e,r,t=null){if(this.name=a,this.type=i,this.arraySize=t,this.bind={[s.Pass]:null,[s.Draw]:null},r)switch(e){case s.Pass:this.bind[s.Pass]=r;break;case s.Draw:this.bind[s.Draw]=r}}equals(s){return this.type===s.type&&this.name===s.name&&this.arraySize===s.arraySize}}export{a as Uniform};
